export const attachUuidPrefix = (id, prefix) =>
  id.includes(prefix) ? id : `${prefix}${id}`;
